import { mdiAccountGroup } from '@mdi/js';
import { MultiSelectCell } from '@pages/User/components';
import type { Team } from '@root/@types/types';
import type { CellContext, ColumnHelper, ColumnMeta } from '@tanstack/react-table';

export const teamsAccessor = <T extends { teams?: number[] }>(
  columnHelper: ColumnHelper<T>,
  teams: Team[] = [],
  filterMeta: ColumnMeta<T, string>['filter'] = {},
  header: string = 'Teams',
) =>
  columnHelper.accessor((row) => row.teams ?? [], {
    id: 'teams',
    header,
    cell: (cellContext: CellContext<T, number[]>) => {
      const teamIds = cellContext.getValue();
      const teamItems = teamIds
        .map((teamId) => {
          const team = teams.find((t) => t.id === teamId);
          return team ? { id: team.id, name: team.name } : null;
        })
        .filter((item): item is { id: number; name: string } => item !== null);

      return (
        <MultiSelectCell
          items={teamItems}
          entityName="Teams"
          entityNameSingular="Team"
          icon={mdiAccountGroup}
          maxWidth="140px"
        />
      );
    },
    enableSorting: false,
    filterFn: 'arrIncludesSome',
    size: 164,
    minSize: 164,
    maxSize: 164,
    meta: {
      headingCellClassName: 'w-44',
      isStandaloneDataCell: true,
      filter: {
        type: 'dropdown',
        placeholder: 'All teams',
        optionsMapping: (Array.isArray(teams) ? teams : []).map((i) => ({
          label: i.name,
          value: i.id,
        })),
        ...filterMeta,
      },
    },
  });
